import { Component } from 'react';
import SpendingController from '../controllers/SpendingController';
import { GeneralObserver } from './Observer';

import { LABELS, UTILITY_CSS_CLASSES } from '../global/constants';
import { makeBEM } from '../global/utils';
import Icon from '../atoms/Icon';
import { RevealAnimation } from './Animations';
import { ConfirmDialog } from './Dialogs';

// import { FormReveal, RevealAnimation } from './Animations';

// import SpendingForm from '../forms/SpendingForm';


class SpendingModule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            controller: new SpendingController(this.props.data),
            animate: this.props.animate ? this.props.animate : false,
            editMode: false,
            deleteAction: this.props.deleteAction,
            showConfirmDialog: false,
        }

        this.moduleName = 'spending';
        this.observer = false;
        this.bindFunctions();
    }

    bindFunctions() {
		this.editSuccess = this.editSuccess.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.reactFn = this.reactFn.bind(this);
        this.promptDeleteConfirm = this.promptDeleteConfirm.bind(this);
        this.discardConfirmDialog = this.discardConfirmDialog.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
    }

    componentDidUpdate(prevProps) {
		if ( this.props.data !== prevProps.data ) {
			this.handlePropChange();
		}
	}

	handlePropChange() {
		const ctrl = this.state.controller;
		ctrl.setSpending(this.props.data);
		this.setState(({
			controller: ctrl,
		}));
	}

    // Creates observer with rectFn 
	// Connects it to the controller
    initialSetup() {
        const ctrl = this.state.controller;
        const deleteAction = this.state.deleteAction;

        this.observer = new GeneralObserver(this.reactFn);
        ctrl.addObserver(this.observer);

        if ( deleteAction ) {
            ctrl.setDeleteAction(deleteAction);
        }

        this.setState({
            controller: ctrl,
        })
    }

    // React fn for observer
	// Updates controller and note states
	reactFn() {
		const ctrl = this.state.controller;

		this.setState({
			controller: ctrl,
		});
	}

    // 
    // Update
    // 

    editSuccess(result) {
        console.log('editSuccess result', result);
        // update log
    }
    
    // 
    // Delete
    // 

    // Delete confirmation
    // Calls deleteAction
    handleDelete() {
        this.discardConfirmDialog();
        const ctrl = this.state.controller;
        ctrl.deleteSelf();
    }

    // 
    // UI
    // 

    toggleEditMode() {
        this.setState({
            editMode: !this.state.editMode
        });
    }

    promptDeleteConfirm() {
        this.setState({
            showConfirmDialog: true
        });
    }

    discardConfirmDialog() {
        this.setState({
            showConfirmDialog: false
        });
    }

    renderContent(log) {
        const cat = log.getCategory();
        const modifier = cat ? `${makeBEM(this.moduleName, 'icon-and-content')}--has-category` : '';
        const wrapperClass = `${makeBEM(this.moduleName, 'icon-and-content')}  ${modifier}`

        return (

            <div className={ wrapperClass }>
                { cat && 
                    <div className={ makeBEM(this.moduleName, 'category-icon-wrapper') } >
                        <Icon customClass={ makeBEM(this.moduleName, 'category-icon') } size={5} type="fill" name={cat.getIconName()}/>
                    </div>
                }
                <div className={ makeBEM(this.moduleName, 'content')} onDoubleClick={ this.promptDeleteConfirm }>
                    <span 
                        className={ makeBEM(this.moduleName, `amount`) }
                    >
                        { log.displayAmount() }
                    </span>
                    <span 
                        className={ makeBEM(this.moduleName, 'date') }
                    >
                        {log.getDateCreatedFormatted()}
                    </span>
                    
                    { log.hasDescription() ?
                        <span className={ makeBEM(this.moduleName, 'description') }>
                            { log.description }
                        </span>
                        :
                        ''
                    }
                </div>
            </div>
        );
    }

    render() {
        const ctrl = this.state.controller;
        if ( !ctrl ) {
            return false;
        }

        const log = ctrl.getSpending();
        const animate = log.animate;
        const editMode = this.state.editMode;
        const editModeClass = editMode ? UTILITY_CSS_CLASSES.editing : '';
        const deleteAction = this.state.deleteAction;
        const showConfirmDialog = this.state.showConfirmDialog;

        return (
            <div className={ `${this.moduleName} ${editModeClass}` }>
                {
                    animate ?
                    <RevealAnimation direction='down'>
                        { this.renderContent(log) }
                    </RevealAnimation>
                    :
                    this.renderContent(log)
                }
                {/* {
                    editMode && 
                    <FormReveal>
                        <SpendingForm
                            log={log.toFormObject()}
                            discardForm={this.toggleEditMode} 
                            editSuccess={this.editSuccess}
                            deleteSuccess={this.handleDeleteAction}
                            controller={ctrl}
                        />
                        { log.toFormObject() }
                    </FormReveal>
                } */}

                {
                    showConfirmDialog &&
                    <ConfirmDialog
                        show={showConfirmDialog}
                        message={LABELS.confirmDelete}
                        confirmAction={this.handleDelete}
                        discardAction={this.discardConfirmDialog}
                    />
                }
            </div>
        );
    }
}

export default SpendingModule;